import React, { useContext } from 'react';
import { List } from 'seedly-component-library';
import Avatar from 'app/seedly-component-library/avatar-new';
import { useSelectFollowedGroupListByUnreadCount } from 'entity/group/groupHooks';
import Link from 'components/misc/Link';
import { Compass } from 'react-feather';
import { useIsSignedIn } from 'entity/user/userHooks';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import { useRouter } from 'next/router';
import clsx from 'clsx';
import ListItem from './ListItem';
import {
  CommunityPageContext,
  PAGE_TYPE,
} from '../context/CommunityPageContext';

const MAX_GROUP_SIDE_BAR = 15;

const GroupSelectList = () => {
  const followedGroups = useSelectFollowedGroupListByUnreadCount();
  const isSignedin = useIsSignedIn();
  const router = useRouter();
  const { groupId, pageType, setPageType } = useContext(CommunityPageContext);

  if (!isSignedin) {
    return null;
  }

  const handleGroupClick = group => {
    const formatGroupName = group.name.toLowerCase().replace(/\s/g, '_');

    mixpanel.track(trackedEvents.SidebarClicked, {
      param: formatGroupName,
    });
  };

  const dataSource = followedGroups
    .filter((_, index) => {
      return index < MAX_GROUP_SIDE_BAR;
    })
    .map(group => {
      const isActive = groupId === group.id && pageType === 'group';
      return (
        <div key={group.id} data-testid={`${group.slug}-group-select`}>
          <Link href={`/community/${group.slug}`} passHref>
            <a onClick={() => handleGroupClick(group)}>
              <ListItem
                icon={<Avatar src={group.profileImage} sizeClass="avatar-6" />}
                isActive={isActive}
                unreadCount={group.unreadCount}
                name={group.name}
              />
            </a>
          </Link>
        </div>
      );
    });

  dataSource.unshift(
    <div
      className="cursor-pointer"
      key="discover"
      onClick={() => {
        mixpanel.track(trackedEvents.SidebarClicked, {
          param: 'discover_groups',
        });
        setPageType('discover-groups');
        const route = '/community?discover=true';
        router.push(route, route, { shallow: true });
      }}
      data-testid="discover-group-select"
    >
      <ListItem
        isActive={pageType === 'discover-groups'}
        icon={
          <Compass
            className={clsx(
              pageType === PAGE_TYPE.DISCOVER_GROUP
                ? 'text-neutral-100'
                : 'text-neutral-700',
            )}
          />
        }
        name="Discover Groups"
      />
    </div>,
  );

  return (
    <List
      dataSource={dataSource}
      headerSpacing="xs"
      listSpacing="xxs"
      width="100%"
      header={
        <div className="flex w-full justify-between items-center px-2 pt-2">
          <div className="text-sm font-bold">
            <p>My Groups</p>
          </div>
          {followedGroups.length > MAX_GROUP_SIDE_BAR && (
            <span
              className="text-blue-500 cursor-pointer"
              onClick={() => setPageType('discover-groups')}
            >
              See All
            </span>
          )}
        </div>
      }
    />
  );
};

export default GroupSelectList;
